import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  customer: {},
  waitingForRedirect: false,
  step: 0,
  orderClosed: false,
  acceptedEmailOptin: false, 
  acceptedPhoneOptin: false,
  acceptedNewsletterOptin: false,
  paymentSession: null,
  notifications: []
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};